import PropTypes from 'prop-types';
import React from 'react';
import { SimpleSnapshotContainer as SnapshotContainer, SnapshotItem } from 'ctm-components';

const PolicyHolderDetails = ({ policyHolderName, policyHolderDob, onClick, getHref }) => {
    const yourDetailsUrl = 'your_details';

    return (
        <SnapshotContainer title="Policy Holder">
            <div className="data-hj-suppress">
                <SnapshotItem identifier="policyHolderName" href={getHref(yourDetailsUrl)} label={policyHolderName} onClick={() => onClick(yourDetailsUrl)} />
                {policyHolderDob && <SnapshotItem className="data-hj-suppress" identifier="policyHolderDob" href={getHref(yourDetailsUrl)} label={`D.O.B - ${policyHolderDob}`} onClick={() => onClick(yourDetailsUrl)} />}
            </div>
        </SnapshotContainer>
    );
};

PolicyHolderDetails.propTypes = {
    policyHolderName: PropTypes.string,
    policyHolderDob: PropTypes.string,
    onClick: PropTypes.func,
    getHref: PropTypes.func
};

export { PolicyHolderDetails };
